import { Dropdown } from 'react-bootstrap';
import Icon from '../../../components/icon/Icon';
import { useStaffPriceEditContext } from '../../../mp/components/Cart/StaffPriceEditContext';

const EditPriceMenuItem = ({ onSelect }: { onSelect: () => void }) => {
  const { startEditing, isEditing } = useStaffPriceEditContext();
  if (isEditing) return null;
  return (
    <Dropdown.Item
      onClick={() => {
        startEditing();
        onSelect();
      }}
      className='py-2'
    >
      <div className='d-flex flex-row align-items-center'>
        <Icon icon='edit' className='mr-2 size-20' hasIconClass={false} />
        <p className='font-14 m-0 mt-1'>Edit</p>
      </div>
    </Dropdown.Item>
  );
};

export default EditPriceMenuItem;
